<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/6siXJG/tc-custom/9781429949934.jpg?1724432673612" alt="This image is the cover for the book Sometimes There Is a Void"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Sometimes There Is a Void
      </h1>
      <p class="bookDescription body article font2">
        <p><b>A <i>New York Times</i> Notable Book of the Year </b><br/><br/><b>South African novelist and playwright Zakes Mda's remarkable life story of growing up in South Africa, Lesotho, and America, told with style and gusto.</b><br/><br/>Zakes Mda is the most acclaimed South African writer of the independence era. His novels tell stories that venture far beyond the conventional narratives of a people's struggle against apartheid. In this memoir, he tells the story of a life that intersects with the political life of his country but that at its heart is the classic adventure story of an artist, lover, father, teacher, and bon vivant. <br/><br/>Zanemvula Mda was born in 1948 into a family of lawyers and grew up in Soweto's ambitious educated black class. At age fifteen he crossed the Telle River from South Africa into Basutoland (Lesotho), exiled like his father, a "founding spirit" of the Pan Africanist Congress. Exile was hard, but it was just another chapter in Mda's coming-of-age. He served as an altar boy (and was preyed on by priests), flirted with shebeen girls, feared the racist Boers, read comic books alongside the literature of the PAC, fell for the music of Dvorák and Coltrane, wrote his first stories—and felt the void at the heart of things that makes him an outsider wherever he goes. The Soweto uprisings called him to politics; playwriting brought him back to South Africa, where he became writer in residence at the famed Market Theatre; three marriages led him hither and yon; acclaim brought him to America, where he began writing the novels that are so thick with the life of his country. <br/><br/>In all this, Mda struggled to remain his own man, and with <i>Sometimes There Is a Void </i>he shows that independence opened the way for the stories of individual South Africans in all their variety.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Zakes Mda
      </h2>
      
      <p class="authorDescription body article"><P><B>Zakes Mda</B> is a professor of creative writing at Ohio University. He has been a visiting professor at both Yale and the University of Vermont. Among his novels, <I>The Heart of Redness </I>(FSG, 2002) won the Richard Wright Zora Neale Hurston Legacy Award. He lives in Johannesburg, South Africa, and Athens, Ohio.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?f46a1ae6